const addSsoTokenQuery = (htmlString: string, ssoToken: string) => {
  let newhtmlString = $(`<div>${htmlString}</div>`);
  let links = newhtmlString.find("a");

  const sameDomainRegex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]raps+)\.org(\?.*)?(\/.*)?$/;
  const sameDomainWithQueryRegex = /^(?:(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]raps+)\.org[a-z0-9\/\.]+)(\?.+)$/;
  const connectRapsOrg = /^(http:\/\/|https:\/\/)?connect\.raps\.org(:[0-9]{1,5})?(\/.*)?$/;
  const myRapsOrg = /^(http:\/\/|https:\/\/)?my\.raps\.org(:[0-9]{1,5})?(\/.*)?$/;

  links.map((index, item) => {
    let href = item.getAttribute("href");
    let isSameDomain = href?.match(sameDomainRegex);
    let isConnectRapsOrg = href?.match(connectRapsOrg);
    let isMyRapsOrg = href?.match(myRapsOrg);

    if (isSameDomain && (isConnectRapsOrg || isMyRapsOrg)) {
      if (href?.match(sameDomainWithQueryRegex)) {
        item.setAttribute("href", `${href}&sso=${ssoToken}`);
      } else {
        item.setAttribute("href", `${href}?sso=${ssoToken}`);
      }
    }
  });

  return newhtmlString.html();
};

export default addSsoTokenQuery;
